import * as React from 'react';
import { useContext,  useState } from 'react';
import { AuthContext } from '../../_auth/AuthContext';
import { Button, Chip, Grid } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { IMembershipSummary, IMemberSummary, IBrazeSummary, IPPSubscriptionSummary } from '../../_types/member';
import RemoteStart from './_remote_start';
import { Typography } from '@material-ui/core';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { MemberRemoteStartDialog } from './MemberRemoteStartDialog';

interface Props {
    member: IMemberSummary;
    membership: IMembershipSummary;
};
interface kvp { key: string, value:any };


const Membership_EW_Summary: React.FC<Props> = (prop: Props) => {

    const { user } = useContext(AuthContext);

    const useStyles = makeStyles((theme) => ({
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120
        },
        table: {
            maxHeight: 440
        },
        paper: {
            width: 768
        },
        section_header: {
            paddingLeft: 10
            
        }
    //     home: { color: "primary" },
    //     away: { color: theme.palette.grey[900] }
    }));

    const classes=useStyles();

    const _ToKVP = ():kvp[] => {

        let toReturn: kvp[] = [];


        let attr: {[index: string]:any} = {};
        attr = prop.membership;

        Object.keys(attr).forEach(key => {
            if (key !== "equipment") {
                if (attr[key] && attr[key].toString().replace(" ","").length > 0) {
                    toReturn.push({key: key, value: attr[key].toString()});
                }
            }
        });            

        

        return toReturn;
    }


    return (
        <Grid item>
        <Paper >
        <Typography className={classes.section_header} variant="h6">EverWash</Typography>
        <TableContainer className={classes.table} >
            <Table size="small">
                
                <TableBody>
                    {_ToKVP().map((e,i) => (
                        <TableRow key={i}>
                            <TableCell>{e.key}</TableCell>
                            <TableCell>{e.value}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    </Paper>
    </Grid>
    )
 
    
}

const MemberShip_Braze_Summary: React.FC<Props> = (prop: Props) => {

    const { user } = useContext(AuthContext);
    const [data,setData] = useState<IBrazeSummary | null>(null);

    React.useEffect(() => {
        setData(_braze());
    },[]);


    const useStyles = makeStyles((theme) => ({
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120
        },
        table: {
            maxHeight: 440
        },
        paper: {
            width: 768
        },
        section_header: {
            paddingLeft: 10
            
        }
    //     home: { color: "primary" },
    //     away: { color: theme.palette.grey[900] }
    }));

    const classes=useStyles();
    const _braze = () => {
        let toReturn: IBrazeSummary | null = null;
        let user_id = prop.member.uuid;
        let membership_id = prop.membership.uuid;

        if (prop.member.braze && prop.member.braze.length > 0) {
            let match = prop.member.braze.find(g => g.external_id === membership_id);
            if (!match) {
                match = prop.member.braze.find(g => g.external_id === user_id); 
            }

            if (match) {
                toReturn = match;
            }
        }

        return toReturn;
    }

    const _brazeToKVP = ():kvp[] => {

        let toReturn: kvp[] = [];

        if (data && data.custom_attributes) {
            let attr: {[index: string]:any} = {};
            attr = data.custom_attributes;

            Object.keys(attr).forEach(key => {
                if (attr[key] && attr[key].toString().replace(" ","").length > 0) {
                    toReturn.push({key: key, value: attr[key].toString()});
                }
                
            });            

        }

        return toReturn;
    }

    if (data) {
    return (
        <Grid item>
        <Paper >
        <Typography className={classes.section_header} variant="h6">Braze</Typography>
        <TableContainer className={classes.table} >
            <Table size="small">
                
                <TableBody>
                    {_brazeToKVP().map((e, i) => (
                        <TableRow key={i}>
                            <TableCell>{e.key}</TableCell>
                            <TableCell>{e.value}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    </Paper>
    </Grid>
    )
    } else { 
        return (<Grid item>No Braze data found</Grid>)
    }
    
}

const MemberShip_PP_Summary: React.FC<Props> = (prop: Props) => {

    const { user } = useContext(AuthContext);
    const [data,setData] = useState<IPPSubscriptionSummary | null>(null);

    React.useEffect(() => {
        setData(_subscription());
    },[]);


    const useStyles = makeStyles((theme) => ({
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120
        },
        table: {
            maxHeight: 440
        },
        paper: {
            width: 768
        },
        section_header: {
            paddingLeft: 10
            
        }
    //     home: { color: "primary" },
    //     away: { color: theme.palette.grey[900] }
    }));

    const classes=useStyles();

    const _subscription = ():IPPSubscriptionSummary | null => {
        let toReturn: IPPSubscriptionSummary | null = null;

        if (prop.member.payment_provider && prop.member.payment_provider.subscriptions &&  prop.member.payment_provider.subscriptions.length > 0) {
            let match = prop.member.payment_provider.subscriptions.find(g => g.pp_id === prop.membership.pp_id);
            
            if (match) {
                toReturn = match;
            }
        }

        return toReturn;
    }

    const _ToKVP = ():kvp[] => {

        let toReturn: kvp[] = [];

        if (data) {
            let attr: {[index: string]:any} = {};
            attr = data;

            Object.keys(attr).forEach(key => {
                if (key !== "latest_invoice" && key !== "next_invoice") {
                    if (attr[key] && attr[key].toString().replace(" ","").length > 0) {
                        toReturn.push({key: key, value: attr[key].toString()});
                    }
                }
                
            });            

        }

        return toReturn;
    }

    if (data) {
    return (
        <Grid item>
        <Paper >
        <Typography className={classes.section_header} variant="h6">Stripe</Typography>
        <TableContainer className={classes.table} >
            <Table size="small">
                
                <TableBody>
                    {_ToKVP().map((e, i) => (
                        <TableRow key={i}>
                            <TableCell>{e.key}</TableCell>
                            <TableCell>{e.value}</TableCell>
                        </TableRow>
                    ))}
                    {data.latest_invoice && (
                        <TableRow>
                            <TableCell>Last Invoice</TableCell>
                            <TableCell>
                                Created: {data.latest_invoice.created}<br/>
                                Date Due: {data.latest_invoice.due}<br/>
                                Amount Due: {data.latest_invoice.amount_due}<br/>
                                Amount Paid: {data.latest_invoice.amount_paid}<br/>
                                Attempts: {data.latest_invoice.attempts}<br/>
                                Status: {data.latest_invoice.status}<br/>
                                {data.latest_invoice.invoice_url && (
                                    <span><a target="_blank" href={data.latest_invoice.invoice_url}>Invoice</a><br/></span>
                                )}
                                {data.latest_invoice.lines?.map((e, i) => (
                                    <span key={i}>{e.amount} - {e.discount_amount}</span>
                                ))}

                             </TableCell>
                        </TableRow>
                    )}
                    {data.next_invoice && (
                        <TableRow>
                            <TableCell>Next Invoice</TableCell>
                            <TableCell>
                                Created: {data.next_invoice.created}<br/>
                                Date Due: {data.next_invoice.due}<br/>
                                Amount Due: {data.next_invoice.amount_due}<br/>
                                Amount Paid: {data.next_invoice.amount_paid}<br/>
                                Attempts: {data.next_invoice.attempts}<br/>
                                Status: {data.next_invoice.status}<br/>
                                {data.next_invoice.invoice_url && (
                                    <span><a target="_blank" href={data.next_invoice.invoice_url}>Invoice</a><br/></span>
                                )}
                                {data.next_invoice.lines?.map((e, i) => (
                                    <span key={i}>{e.amount} - {e.discount_amount}</span>
                                ))}

                             </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    </Paper>
    </Grid>
    )
    } else { 
        return (<Grid item>No Stripe data found</Grid>)
    }
    
}

const Membership: React.FC<Props> = (prop: Props) => {

    const { user } = useContext(AuthContext);
    const [showDialog, setShowDialog] = useState<boolean>(false);

    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            root: {
                width: '100%',
                marginTop: 10
                },
            padLeft: {
                marginLeft: 3
            },
            interfaces: {
                paddingLeft: 10,
                borderLeftColor: theme.palette.primary.dark,
                borderLeftWidth: 3,
                borderLeftStyle: "solid"
            },
            status_cancelled: { color: "red" },
            status_active: { color: "green" }
        }),
    );
    const classes = useStyles();

    const _status = ():string => {
        if (prop.membership.cancelled) {
            return "cancelled";
        } else if (prop.membership.frozen) {
            return "frozen until " + prop.membership.unfreeze_dt;
        } else {
            return "active";
        }
    }
    

    const equipment = prop.membership.equipment?.filter(e => {
        const interfaces = e.interfaces?.filter(i => {
            return i.triggers?.indexOf('interfacetrigger.remotescan') !== -1
        });

        return interfaces && interfaces.length > 0;
    })

    return (

        <Grid container direction="column" justify="flex-start" alignItems="stretch" spacing={2}>
            
            <Grid item>
                <Grid container direction="row" justify="flex-start" alignItems="stretch" spacing={2}>
                    <Grid item><Typography variant="h6">{prop.membership.location_name} - {prop.membership.plan_name}</Typography></Grid>
                    <Grid item className={classes.padLeft}>(${prop.membership.plan_price})</Grid>
                    <Grid item className={classes.padLeft} ><Chip size="small" variant="outlined" color="secondary" label={_status()} /></Grid>
                    {equipment && equipment.length > 0 &&
                        <>
                            <Grid item className={classes.padLeft}><Button variant="contained" color="primary" onClick={n => setShowDialog(true)}>REMOTE START &#x2026;</Button></Grid>
                            <MemberRemoteStartDialog show={showDialog} equipment={equipment} userId={prop.member.id} membershipId={prop.membership.uuid} onClose={() => setShowDialog(false)}></MemberRemoteStartDialog>
                        </>
                    }
                </Grid>
            </Grid>
            <Grid item>
                <Grid container direction="row" justify="flex-start" alignItems="stretch" spacing={2}>
                    <Membership_EW_Summary member={prop.member} membership={prop.membership}></Membership_EW_Summary>
                    <MemberShip_Braze_Summary member={prop.member} membership={prop.membership}></MemberShip_Braze_Summary>
                    <MemberShip_PP_Summary member={prop.member} membership={prop.membership}></MemberShip_PP_Summary>
                </Grid>
            </Grid>
        </Grid>

        )
    }

export default Membership;